let idCount = 0

/**
 * Dead simple unique ID implementation.
 * Thanks lodash!
 * @return {number}
 */
function uniqueId() {
  return ++idCount
}

export default uniqueId



// WEBPACK FOOTER //
// ./src/components/Tools/VueSelect/utility/uniqueId.js